import React from "react";

import clsx from "clsx";

import useCarousel from "./use-carousel";

type Props = {
  className?: string;
  inactiveClassName?: string;
};

const IndicatorDots = ({ className, inactiveClassName = "bg-gray-600" }: Props) => {
  const { stepIndex, steps, goToStep } = useCarousel();
  return (
    <div className={clsx("flex space-x-2 items-center justify-center", className)}>
      {steps.map((step, index) => (
        <div
          key={step.title}
          className={clsx(
            "h-3 w-3 rounded-full transition-colors shadow-md",
            index === stepIndex ? "bg-primary" : inactiveClassName
          )}
          onClick={() => goToStep(index)}
        />
      ))}
    </div>
  );
};

export default IndicatorDots;
